export default __webpack_public_path__ + "static/media/au_dlpm.90320bac.jpg";